module.exports = __webpack_public_path__ + "img/11-2.ea3b6acb.png";